import { createVanIconComponent } from "./van"

const ShieldOutlined = createVanIconComponent("shield-o")
export default ShieldOutlined
